import * as React from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { createTagsOptions } from 'lib/participantProfile/Helper'
import { ParticipantTagInput } from 'types/Participants'
import { useAppSelector } from 'redux/Hook'
import { MAX_PARTICIPANT_TAGS_CHAR } from 'lib/GlobalConstants'

type BulkTagsOptionProps = {
  selectedTags: any
  onChange: (tags: ParticipantTagInput[]) => void
  hasError: boolean
}

const BulkTagsOption = ({
  selectedTags,
  onChange,
  hasError,
}: BulkTagsOptionProps) => {
  const { t } = useTranslation()
  const participantTags = useAppSelector((state) => state.participantTags)

  const handleChange = (tags: ParticipantTagInput[]) => onChange(tags)

  const [inputValue, setInputValue] = React.useState('')

  const validBulkTagInputRegex = /^[a-z0-9&_\-']*$/gim

  const handleInputChange = (value: string) => {
    // set the valid input value based on the below conditions
    if (
      validBulkTagInputRegex.test(value) &&
      value.length <= MAX_PARTICIPANT_TAGS_CHAR
    ) {
      setInputValue(value)
    }
  }
  return (
    <Autocomplete
      multiple
      limitTags={6}
      options={participantTags.data}
      value={selectedTags}
      inputValue={inputValue}
      getOptionLabel={(option) => option.name}
      handleHomeEndKeys
      selectOnFocus
      clearOnBlur
      data-testid="bulk-tag-input"
      openText={t('filters.ariaTexts.open')}
      closeText={t('filters.ariaTexts.close')}
      onChange={(e, value) => handleChange(value)}
      filterSelectedOptions
      onInputChange={(_, value) => handleInputChange(value)}
      filterOptions={(options, params) =>
        createTagsOptions(
          options,
          params,
          t('participant.tags.create'),
          selectedTags,
        )
      }
      noOptionsText={t('common.noOptions')}
      renderInput={(params: any) => {
        const isEmpty = !params.inputProps.value
        const isError = isEmpty && hasError

        const helperText = isError
          ? t('participant.bulkTag.emptyError')
          : t('participant.bulkTag.helpText')

        return (
          <TextField
            {...params}
            variant="standard"
            error={isError}
            label={t('participant.tags.inputLabel')}
            placeholder={t('participant.tags.placeholder')}
            helperText={helperText}
          />
        )
      }}
    />
  )
}

export default BulkTagsOption
